// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Dna_wrapper__3VuEv","container":"Dna_container__3i0FG","img1":"Dna_img1__3O12-"};